import anylogger from 'anylogger';
import { REACT_SOCKET_NOTIFICATION_LOG_NAMESPACE } from '../config';
export const logger = anylogger(REACT_SOCKET_NOTIFICATION_LOG_NAMESPACE);
//# sourceMappingURL=logger.js.map